import React, { Component } from 'react';
import { navigationFetcher, Navigation } from '@noths/global-components-v2';
import Logger from '@noths/logger/build/client';

export class GlobalNavigation extends Component {
  constructor() {
    super();

    this.state = {
      navData: [],
    };
  }

  async componentWillMount() {
    const navData = await navigationFetcher('live').catch(err => {
      Logger.error(`Error fetching nav: ${err}`);

      return [];
    });

    this.setState({
      navData,
    });
  }

  render() {
    return <Navigation navData={this.state.navData} />;
  }
}

export default GlobalNavigation;
